import { CircularProgress, Stack, Typography } from '@mui/material';
import { RestApiKey } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import * as React from 'react';
import useWizardStepContext from 'v2/components/WizardModal/useWizardStepContext';

const STEP_INDEX = 1;

interface Props {
  name: string;
  onGenerated: (apiKey: string) => void;
  addApiKey: (description: string) => Promise<RestApiKey | undefined>;
}

const GeneratingKeyStep: React.FC<Props> = ({ name, onGenerated, addApiKey }) => {
  const { translation } = useTranslation();
  const { goToNext, setFooterContent } = useWizardStepContext();

  React.useLayoutEffect(() => {
    setFooterContent(STEP_INDEX, <></>);
  }, [setFooterContent]);

  const hasFired = React.useRef(false);

  React.useEffect(() => {
    if (!name || hasFired.current) return;
    hasFired.current = true;

    addApiKey(name).then((result) => {
      if (result) {
        onGenerated(result.apiKey);
        goToNext();
      }
    });
  }, [name]);

  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 6 }}>
      <CircularProgress />
      <Typography>{translation.generating_key}</Typography>
    </Stack>
  );
};

export default GeneratingKeyStep;
